<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="transactionsTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="first-transactions" class="nav-link" data-bs-toggle="tab" data-bs-target="#firstTransactions"
              type="button" role="tab" aria-controls="firstTransactions" aria-selected="true" @click="onClickTab('1')">
              {{ $t("content.gmoneyhis") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="second-transactions" class="nav-link" data-bs-toggle="tab" data-bs-target="#secondTransactions"
              type="button" role="tab" aria-controls="secondTransactions" aria-selected="false"
              @click="onClickTab('2')">
              {{ $t("content.gmoneybiz") }}
            </button>
          </li>
        </ul>

        <div id="transactionsTabContent" class="tab-content">
          <div id="firstTransactions" class="tab-pane fade show active" role="tabpanel"
            aria-labelledby="first-transactions">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.gmoneyhis") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.sdate") }}</label>
                    <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                      :max-date="new Date()" :enable-time-picker="false" month-name-format="long" :clearable="false"
                      :text-input="textInputOptions" fluid />
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                    <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                      :max-date="new Date()" :enable-time-picker="false" month-name-format="long" :clearable="false"
                      :text-input="textInputOptions" fluid />
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{
                      $t("content.amnsourcemoney")
                    }}</label>
                    <select v-model="search_sourcemoney" class="form-select">
                      <option value="" selected>{{ $t("content.optall") }}</option>
                      <optgroup :label="$t('apps.mcash')">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{
                      $t("content.tosource")
                    }}</label>
                    <select v-model="search_target" class="form-select">
                      <option value="" selected>{{ $t("content.optall") }}</option>
                      <optgroup :label="$t('apps.mcash')">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.trans") }}</label>
                    <select class="form-select" v-model="search_trans">
                      <option value="" selected>{{ $t("content.optall") }}</option>
                      <option value="txDeposit" selected> {{ $t(datas.types[0].lb) }}
                      </option>
                      <option value="txWithdrawal" selected> {{
                        $t(datas.types[1].lb) }}
                      </option>
                      <option value="txTransfer" selected> {{ $t(datas.types[2].lb) }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.transc") }}</label>
                    <select class="form-select" v-model="search_cat" @change="checkSubCat">
                      <option value="" selected>{{ $t("content.optall") }}</option>
                      <option v-for="(a, opt1) in datas.FinancAll" :key="opt1" :value="a.val">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.transc_sub") }}</label>
                    <select class="form-select" v-model="search_subcat" :disabled="search_cat === ''">
                      <option value="" selected>{{ $t("content.optall") }}</option>
                      <option v-for="(a, opt1) in listsubcat" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>




                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch-fn" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="loadDataApi" :disabled="start_date > end_date">
                        <i class="material-icons material-symbols-outlined">search</i> {{ $t("buttons.sear") }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ btnCancel }}
                      </material-button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.transc") }}</th>
                          <th>{{ $t("content.transc_sub") }}</th>
                          <th>{{ $t("content.transac") }}</th>
                          <th>{{ $t("content.fromsource") }}</th>
                          <th>{{ $t("content.tosource") }}</th>
                          <th>{{ $t("content.amount") }}</th>
                          <th>{{ $t("content.detail") }}</th>
                          <th>{{ $t("content.ticketref") }}</th>
                          <th>{{ $t("content.cname") }}</th>
                          <th>{{ $t("content.file") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr v-for="(row, index) in listfundTx" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ format_datetime(row.txDate) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterfundCategory(row.fundCategory) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterfundTranType(row.fundTranTypeId) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.txType === 'TRANSFER'">
                              {{ $t(datas.types[2].lb) }}
                            </span>
                            <span v-else-if="row.txType === 'WITHDRAW'">
                              {{ $t(datas.types[1].lb) }}
                            </span>
                            <span v-else-if="row.txType === 'DEPOSIT'">
                              {{ $t(datas.types[0].lb) }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.sourceUid === '0' && row.sourceType !== 'OTHERS'">
                              -
                            </span>
                            <span v-else-if="row.sourceType !== 'OTHERS'">
                              {{ filterMoneySource(row.sourceUid) }}
                            </span>
                            <span v-else>
                              {{ $t("content.amnothers") }} ({{ row.sourceAccNumber }})
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            <span v-if="row.targetUid === '0' && row.targetType !== 'OTHERS'">
                              -
                            </span>
                            <span v-else-if="row.targetType !== 'OTHERS'">
                              {{ filterMoneySource(row.targetUid) }}
                            </span>
                            <span v-else>
                              {{ $t("content.amnothers") }} ({{ row.targetAccNumber }})
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.txAmount) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.detail }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.refNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.cusName }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              v-if="row.refDocUid !== '0'" @click="getFileRef(row)">
                              <i class="material-icons material-symbols-outlined">attach_file</i>
                            </material-button>
                            <material-button color="primary" data-bs-toggle="modal" data-bs-target="#attachmentsModal"
                              v-show="false" id="attachmenDialog">
                              <i class="material-icons material-symbols-outlined">attach_file</i>
                            </material-button>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle me-1"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="btnEdit"
                              :disabled="format_date(row.txDate) !== format_date(new Date())"
                              @click="editRowItems(row)">
                              <i class="material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button color="danger" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="btnDel"
                              @click="deleteRowItems(row)"
                              :disabled="format_date(row.txDate) !== format_date(new Date())">
                              <i class=" material-icons material-symbols-outlined">delete</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listfundTx.length === 0">
                          <td colspan="12" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="13" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listfundTx.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="secondTransactions" class="tab-pane fade" role="tabpanel" aria-labelledby="second-transactions">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.gmoneybiz") }}</h5>
              </div>
              <div class="card-body pt-0">

                <div class="row">
                  <div class="col-3 mb-4">
                    <label class="form-label ms-0">{{ $t("content.issuedate") }}</label>
                    <VueDatePicker v-model="fundtx_detail.txDate" :format="format" auto-apply :teleport="true" disabled
                      :max-date="new Date()" :enable-time-picker="false" month-name-format="long" :clearable="false"
                      :text-input="textInputOptions" fluid />
                  </div>
                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.transc") }}</label>
                    <select class="form-select" v-model="fundtx_detail.fundCategory" @change="checkSubCat_AE"
                      :disabled="fundtx_detail.uid !== ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in datas.FinancAll" :key="opt1" :value="a.val">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.transc_sub") }}</label>
                    <select class="form-select" v-model="fundtx_detail.fundTranTypeId"
                      :disabled="fundtx_detail.fundCategory === '' || fundtx_detail.uid !== ''" @change="checkTrans_AE">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listsubcat_ae" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-3" v-if="listtransc_ae.length > 0">
                    <label class="form-label ms-0">{{ $t("content.trans") }}</label>
                    <select class="form-select" v-model="fundtx_detail.txType"
                      :disabled="fundtx_detail.fundTranTypeId === '' || fundtx_detail.uid !== ''"
                      @change="checkSource_AE">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-if="listtransc_ae[0].txDeposit" value="txDeposit" selected> {{ $t(datas.types[0].lb) }}
                      </option>
                      <option v-if="listtransc_ae[0].txWithdrawal" value="txWithdrawal" selected> {{
                        $t(datas.types[1].lb) }}
                      </option>
                      <option v-if="listtransc_ae[0].txTransfer" value="txTransfer" selected> {{ $t(datas.types[2].lb)
                      }}
                      </option>
                    </select>
                  </div>
                  <div v-else class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.trans") }}</label>
                    <select class="form-select" v-model="fundtx_detail.txType"
                      :disabled="fundtx_detail.fundTranTypeId === '' || fundtx_detail.uid !== ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                    </select>
                  </div>
                </div>

                <div class="row" v-if="fundtx_detail.sourceUid !== 'OTHERS' && fundtx_detail.targetUid !== 'OTHERS'">
                  <div class="col-lg-3" v-if="listsource_ae.length > 0">
                    <label class="form-label ms-0">{{ $t("content.fromsource") }}</label>
                    <select v-model="fundtx_detail.sourceUid" class="form-select" @change="changeSource"
                      :disabled="fundtx_detail.txType === '' || listsource_ae[0].srcNone || fundtx_detail.uid !== ''">
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                      <optgroup :label="$t('apps.mcash')" :disabled="!listsource_ae[0].srcCashAccount">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')" :disabled="!listsource_ae[0].srcBankAccount">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')" v-if="fundtx_detail.fundCategory === 'EXTERNAL'
                        || fundtx_detail.fundCategory === 'DIRECTOR_LOAN' || fundtx_detail.fundCategory === 'SELLING_PRODUCTS'
                        || fundtx_detail.fundCategory === 'FEE' || fundtx_detail.fundCategory === 'ACCOUNT_ADJUST'"
                        :disabled="(!listsource_ae[0].srcCashAccount && !listsource_ae[0].srcBankAccount) || fundtx_detail.targetUid === 'OTHERS'">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-else class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.fromsource") }}</label>
                    <select v-model="fundtx_detail.sourceUid" class="form-select" disabled>
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                    </select>
                  </div>

                  <div v-if="listsource_ae.length > 0" class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.tosource") }}</label>
                    <select v-model="fundtx_detail.targetUid" class="form-select" @change="changeTarget"
                      :disabled="fundtx_detail.txType === '' || listsource_ae[0].dstNone || fundtx_detail.uid !== ''">
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                      <optgroup :label="$t('apps.mcash')" :disabled="!listsource_ae[0].dstCashAccount">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')" :disabled="!listsource_ae[0].dstBankAccount">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')" v-if="fundtx_detail.fundCategory === 'EXTERNAL'
                        || fundtx_detail.fundCategory === 'DIRECTOR_LOAN' || fundtx_detail.fundCategory === 'SELLING_PRODUCTS'
                        || fundtx_detail.fundCategory === 'FEE' || fundtx_detail.fundCategory === 'ACCOUNT_ADJUST'"
                        :disabled="(!listsource_ae[0].dstCashAccount && !listsource_ae[0].dstBankAccount) || fundtx_detail.sourceUid === 'OTHERS'">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-else class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.tosource") }}</label>
                    <select v-model="fundtx_detail.targetUid" class="form-select" disabled>
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                    </select>
                  </div>

                  <div class="flex-auto col-lg-3">
                    <label class="form-label ms-0">
                      {{ $t("content.amount") }}
                    </label>
                    <div class="align-items-center">
                      <InputNumber v-model="fundtx_detail.txAmount" :maxFractionDigits="2" autocomplete="off"
                        @focus="$event.target.select()" fluid />
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <div class="d-flex align-items-center mb-1">
                      <label class="form-label ms-0">
                        {{ $t("content.file") }}
                      </label>
                    </div>
                    <input id="upload" type="file" accept="application/pdf,image/*" @change="addFile" />
                  </div>
                </div>

                <div class="row" v-if="fundtx_detail.sourceUid === 'OTHERS'">
                  <div class="col-lg-3" v-if="listsource_ae.length > 0">
                    <label class="form-label ms-0">{{ $t("content.fromsource") }}</label>
                    <select v-model="fundtx_detail.sourceUid" class="form-select" @change="changeSource"
                      :disabled="fundtx_detail.txType === '' || listsource_ae[0].srcNone">
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                      <optgroup :label="$t('apps.mcash')" :disabled="!listsource_ae[0].srcCashAccount">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')" :disabled="!listsource_ae[0].srcBankAccount">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')" v-if="fundtx_detail.fundCategory === 'EXTERNAL'
                        || fundtx_detail.fundCategory === 'DIRECTOR_LOAN' || fundtx_detail.fundCategory === 'SELLING_PRODUCTS'
                        || fundtx_detail.fundCategory === 'FEE' || fundtx_detail.fundCategory === 'ACCOUNT_ADJUST'"
                        :disabled="(!listsource_ae[0].srcCashAccount && !listsource_ae[0].srcBankAccount) || fundtx_detail.targetUid === 'OTHERS'">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-else class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.fromsource") }}</label>
                    <select v-model="fundtx_detail.sourceUid" class="form-select" disabled>
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                    </select>
                  </div>

                  <div v-if="fundtx_detail.sourceUid === 'OTHERS'" class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.detail") }}{{ $t("content.fromsource") }}</label>
                    <material-input v-model="fundtx_detail.sourceAccNumber" type="text" autocomplete="off" />
                  </div>

                  <div v-if="listsource_ae.length > 0" class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.tosource") }}</label>
                    <select v-model="fundtx_detail.targetUid" class="form-select" @change="changeTarget"
                      :disabled="fundtx_detail.txType === '' || listsource_ae[0].dstNone">
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                      <optgroup :label="$t('apps.mcash')" :disabled="!listsource_ae[0].dstCashAccount">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')" :disabled="!listsource_ae[0].dstBankAccount">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')" v-if="fundtx_detail.fundCategory === 'EXTERNAL'
                        || fundtx_detail.fundCategory === 'DIRECTOR_LOAN' || fundtx_detail.fundCategory === 'SELLING_PRODUCTS'
                        || fundtx_detail.fundCategory === 'FEE' || fundtx_detail.fundCategory === 'ACCOUNT_ADJUST'"
                        :disabled="(!listsource_ae[0].dstCashAccount && !listsource_ae[0].dstBankAccount) || fundtx_detail.sourceUid === 'OTHERS'">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-else class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.tosource") }}</label>
                    <select v-model="fundtx_detail.targetUid" class="form-select" disabled>
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                    </select>
                  </div>

                  <div class="flex-auto col-lg-6">
                    <label class="form-label ms-0">
                      {{ $t("content.amount") }}
                    </label>
                    <div class="align-items-center">
                      <InputNumber v-model="fundtx_detail.txAmount" :maxFractionDigits="2" autocomplete="off"
                        @focus="$event.target.select()" fluid />
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="d-flex align-items-center mb-1">
                      <label class="form-label ms-0">
                        {{ $t("content.file") }}
                      </label>
                    </div>
                    <input id="upload" type="file" accept="application/pdf,image/*" @change="addFile" />
                  </div>
                </div>

                <div class="row" v-if="fundtx_detail.targetUid === 'OTHERS'">
                  <div class="col-lg-3" v-if="listsource_ae.length > 0">
                    <label class="form-label ms-0">{{ $t("content.fromsource") }}</label>
                    <select v-model="fundtx_detail.sourceUid" class="form-select" @change="changeSource"
                      :disabled="fundtx_detail.txType === '' || listsource_ae[0].srcNone">
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                      <optgroup :label="$t('apps.mcash')" :disabled="!listsource_ae[0].srcCashAccount">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')" :disabled="!listsource_ae[0].srcBankAccount">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')" v-if="fundtx_detail.fundCategory === 'EXTERNAL'
                        || fundtx_detail.fundCategory === 'DIRECTOR_LOAN' || fundtx_detail.fundCategory === 'SELLING_PRODUCTS'
                        || fundtx_detail.fundCategory === 'FEE' || fundtx_detail.fundCategory === 'ACCOUNT_ADJUST'"
                        :disabled="(!listsource_ae[0].srcCashAccount && !listsource_ae[0].srcBankAccount) || fundtx_detail.targetUid === 'OTHERS'">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-else class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.fromsource") }}</label>
                    <select v-model="fundtx_detail.sourceUid" class="form-select" disabled>
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                    </select>
                  </div>

                  <div v-if="listsource_ae.length > 0" class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.tosource") }}</label>
                    <select v-model="fundtx_detail.targetUid" class="form-select" @change="changeTarget"
                      :disabled="fundtx_detail.txType === '' || listsource_ae[0].dstNone">
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                      <optgroup :label="$t('apps.mcash')" :disabled="!listsource_ae[0].dstCashAccount">
                        <option v-for="(item, index) in listcashAcc" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.amnbankacc')" :disabled="!listsource_ae[0].dstBankAccount">
                        <option v-for="(item, index) in listbankpawn" :value="item.uid" :key="index">
                          {{ item.shortName }}
                        </option>
                      </optgroup>
                      <optgroup :label="$t('content.source_others')" v-if="fundtx_detail.fundCategory === 'EXTERNAL'
                        || fundtx_detail.fundCategory === 'DIRECTOR_LOAN' || fundtx_detail.fundCategory === 'SELLING_PRODUCTS'
                        || fundtx_detail.fundCategory === 'FEE' || fundtx_detail.fundCategory === 'ACCOUNT_ADJUST'"
                        :disabled="(!listsource_ae[0].dstCashAccount && !listsource_ae[0].dstBankAccount) || fundtx_detail.sourceUid === 'OTHERS'">
                        <option value="OTHERS" selected>{{ $t("content.amnothers") }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-else class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.tosource") }}</label>
                    <select v-model="fundtx_detail.targetUid" class="form-select" disabled>
                      <option value="0" disabled selected>{{ $t("content.select") }}</option>
                    </select>
                  </div>

                  <div v-if="fundtx_detail.targetUid === 'OTHERS'" class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.detail") }}{{ $t("content.tosource") }}</label>
                    <material-input v-model="fundtx_detail.targetAccNumber" type="text" autocomplete="off" />
                  </div>

                  <div class="flex-auto col-lg-6">
                    <label class="form-label ms-0">
                      {{ $t("content.amount") }}
                    </label>
                    <div class="align-items-center">
                      <InputNumber v-model="fundtx_detail.txAmount" :maxFractionDigits="2" autocomplete="off"
                        @focus="$event.target.select()" fluid />
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="d-flex align-items-center mb-1">
                      <label class="form-label ms-0">
                        {{ $t("content.file") }}
                      </label>
                    </div>
                    <input id="upload" type="file" accept="application/pdf,image/*" @change="addFile" />
                  </div>

                </div>



                <div class="row">
                  <div class="col-lg-12">
                    <label class="form-label ms-0">{{ $t("content.detail") }}</label>
                    <material-input v-model="fundtx_detail.detail" type="text" autocomplete="off" />
                  </div>

                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.ticketref") }}</label>
                    <material-input v-model="fundtx_detail.refNumber" type="text" autocomplete="off"
                      :disabled="fundtx_detail.fundCategory !== 'EXTERNAL' && fundtx_detail.fundCategory !== 'ACCOUNT_ADJUST' && fundtx_detail.fundCategory !== 'SELLING_PRODUCTS'" />
                  </div>

                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.cname") }}</label>
                    <material-input v-model="fundtx_detail.cusName" type="text" autocomplete="off"
                      :disabled="fundtx_detail.fundCategory !== 'EXTERNAL' && fundtx_detail.fundCategory !== 'ACCOUNT_ADJUST' && fundtx_detail.fundCategory !== 'SELLING_PRODUCTS'" />
                  </div>
                </div>

                <div class="row no-gutters mt-3">
                  <div class="col-12 d-flex justify-content-end">
                    <div>
                      <material-button color="default" class="float-lg-start float-sm-end mb-3 me-3" @click="clearItem">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ btnCancel }}
                      </material-button>

                      <material-button 
                        color="primary" 
                        class="float-lg-start float-sm-end mb-3"
                        :disabled="isSaveDisabled || isLoading" 
                        @click="confirmNewRecord"
                        @keydown.enter.prevent>
                        <i class="material-icons material-symbols-outlined">
                          {{ isLoading ? 'hourglass_top' : 'save' }}
                        </i>
                        {{ isLoading ? 'กำลังบันทึก...' : btnSave }}
                      </material-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Attachments Dialog -->
        <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div id="attachmentsImages" class="carousel slide" data-bs-ride="carousel">
                  <div class="carousel-indicators" id="demo2">
                  </div>
                  <div class="carousel-inner" id="demo3">
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#attachmentsImages"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#attachmentsImages"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import InputNumber from 'primevue/inputnumber';
import { reactive, inject, computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import ExampleFive from "@/examples/ExampleOne";


import { useCashAccountStore } from '@/stores/cashaccount'
import { useShopBankStore } from '@/stores/shopbank'
import { useFinancialTranTypeStore } from '@/stores/financialtrantype'
import { useFundTxStore } from '@/stores/fundtx'
import { useDocumentStore } from '@/stores/document'

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import { version } from 'dropzone';


const storec = useCashAccountStore()
const storesb = useShopBankStore()
const storef = useFinancialTranTypeStore()
const storefund = useFundTxStore()
const storedoc = useDocumentStore()

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const { t } = useI18n();
const swal = inject("$swal");


const datas = reactive({
  addNew: false,
  rowEdit: false,
  coreCopy: true,
  coreBox1: "",
  file: [],
  demo1: [
    { items: "ปิดยอดเงินสด" },
    { items: "ปิดยอดบัญชีธนาคาร" },
    { items: "ธุรกรรมเงินสด" },
    { items: "ธุรกรรมบัญชีธนาคาร" },
  ],
  demo2: [{ items: "ฝาก" }, { items: "ถอน" }],
  demo3: [{ items: "เงินสด" }, { items: "เงินโอน" }],
  demo4: [{ items: "Bank1" }, { items: "Bank2" }],
  demo2s: [
    { items: computed(() => t("content.select")) },
    { items: computed(() => t("content.ctranstde")) },
    { items: computed(() => t("content.ctranstwi")) },
  ],
  FinancAll: [
    { items: computed(() => t("content.ctranstin")), val: 'INTERNAL' },
    { items: computed(() => t("content.ctranstout")), val: 'EXTERNAL' },
    { items: computed(() => t("content.direct_lo")), val: 'DIRECTOR_LOAN' },
    { items: computed(() => t("content.sell_pr")), val: 'SELLING_PRODUCTS' },
    { items: computed(() => t("content.fee")), val: 'FEE' },
    { items: computed(() => t("content.ctranstexp")), val: 'EXPENSE' },
    { items: computed(() => t("content.ctranstacc")), val: 'ACCOUNT_CLOSURE' },
    { items: computed(() => t("content.acc_adj")), val: 'ACCOUNT_ADJUST' },
  ],
  Financ1: [
    { items: computed(() => t("content.select")) },
    { items: computed(() => t("content.ctranstca")) },
    { items: computed(() => t("content.ctranstbc")) },
    { items: computed(() => t("content.ctranstii")) },
  ],
  Financ2: [
    { items: computed(() => t("content.select")) },
    { items: computed(() => t("content.ctranstoi")) },
  ],
  Financ3: [
    { items: computed(() => t("content.select")) },
    { items: computed(() => t("content.ctranstge")) },
  ],
  Financ4: [
    { items: computed(() => t("content.select")) },
    { items: computed(() => t("content.ctranstcs")) },
    { items: computed(() => t("content.ctranstco")) },
    { items: computed(() => t("content.ctranstuc")) },
  ],
  options: [
    {
      items: computed(() => t("content.transac") + " -> " + t("content.actpawn1")),
    },
    {
      items: computed(() => t("content.transac") + " -> " + t("content.actpawn2")),
    },
    {
      items: computed(() => t("content.transac") + " -> " + t("content.actpawn3")),
    },
    {
      items: computed(() => t("content.transac") + " -> " + t("content.actpawn4")),
    },
    {
      items: computed(() => t("content.transac") + " -> " + t("content.actpawn5")),
    },
    {
      items: computed(() => t("content.transac") + " -> " + t("content.actpawn6")),
    },
    {
      items: computed(() => t("content.transac") + " -> " + t("content.deposite")),
    },
    {
      items: computed(() => t("content.transac") + " -> " + t("content.withdraw")),
    },
    {
      items: computed(() => t("content.inshop") + " -> " + t("content.transcash")),
    },
    {
      items: computed(() => t("content.inshop") + " -> " + t("content.transbank")),
    },
    {
      items: computed(() => t("content.inshop") + " -> " + t("content.transin")),
    },
    {
      items: computed(() => t("content.outshop") + " -> " + t("content.transout")),
    },
    {
      items: computed(() => t("content.expense") + " -> " + t("content.genexp")),
    },
    {
      items: computed(() => t("content.accclose") + " -> " + t("content.cashshort")),
    },
    {
      items: computed(() => t("content.accclose") + " -> " + t("content.cashover")),
    },
    {
      items: computed(() => t("content.accclose") + " -> " + t("content.unreccash")),
    },
  ],
  types: [
    {
      id: "selectedDepo",
      vl: 0,
      lb: "content.ctranstde",
    },
    {
      id: "selectedWithd",
      vl: 1,
      lb: "content.ctranstwi",
    },
    {
      id: "selectedTrans",
      vl: 2,
      lb: "content.ctransttr",
    },
  ],
});


const btnSave = computed(() => t("buttons.save"));
const btnCancel = computed(() => t("buttons.canc"));
const shop_detail = ref(null)
const listcashAcc = ref([]);
const listbankpawn = ref([]);
const start_date = ref(new Date(new Date().setHours(0, 0, 0, 0)));
const end_date = ref(new Date());
const listfinancialtrans = ref([]);
const listsubcat = ref([]);
const listfundTx = ref([]);
const listsubcat_ae = ref([]);
const listtransc_ae = ref([]);
const listsource_ae = ref([]);

const search_cat = ref('');
const search_subcat = ref('');
const search_trans = ref('');
const search_sourcemoney = ref('');
const search_target = ref('');

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const fundtx_detail = ref({
  uid: '',
  txDate: new Date(),
  fundCategory: '',
  fundTranTypeId: '',
  txType: '',
  sourceType: '',
  sourceUid: '0',
  targetType: '',
  targetUid: '0',
  txAmount: '',
  detail: '',
  refDocUid: '0',
  version: '',
  targetAccNumber: '',
  sourceAccNumber: '',
  cusName: '',
  refNumber: '',
  fundTranTypeName: '',
  sourceAccName: '',
  targetAccName: '',

});

const thumb_name = ref("");
const thumb = ref(null);
const thumb_id = ref('');
const loading = ref(false);
const images = ref([])
const regex = /data:.*base64,/
const mimeType = ref("");
const isLoading = ref(false)
const file_d = ref(null);

const isSaveDisabled = computed(() => {
  const detail = fundtx_detail.value;
  const listSource = listsource_ae.value; 

  // 1. เช็คค่าพื้นฐาน
  const isBasicInvalid = !detail.fundCategory || !detail.fundTranTypeId || !detail.txType;
  const isSourceInvalid = detail.sourceUid === '0';
  
  // 💡 แกไขให้ตรงตาม logic เดิมของคุณ: เช็คความยาวอาร์เรย์ และดึง dstNone จากอาร์เรย์ตัวแรก [0]
  const isTargetInvalid = detail.targetUid === '0' && 
                          listSource && 
                          listSource.length > 0 && 
                          !listSource[0].dstNone;
  
  const isAmountInvalid = !detail.txAmount || Number(detail.txAmount) === 0;
  const isDetailInvalid = !detail.detail || detail.detail.trim() === '';
  const isSameAccount = detail.sourceUid === detail.targetUid;

  // 2. เช็คกรณี OTHERS 
  const isOtherSourceInvalid = detail.sourceUid === 'OTHERS' && (!detail.sourceAccNumber || detail.sourceAccNumber.trim() === '');
  const isOtherTargetInvalid = detail.targetUid === 'OTHERS' && (!detail.targetAccNumber || detail.targetAccNumber.trim() === '');

  // 3. เช็คกรณี ACCOUNT_ADJUST
  const isAdjustInvalid = detail.fundCategory === 'ACCOUNT_ADJUST' && (
    !detail.refNumber || detail.refNumber.trim() === '' ||
    !detail.cusName || detail.cusName.trim() === ''
  );

  return isBasicInvalid || isSourceInvalid || isTargetInvalid || isAmountInvalid || 
         isDetailInvalid || isSameAccount || isOtherSourceInvalid || 
         isOtherTargetInvalid || isAdjustInvalid;
});



const onClickHandler = () => {
  updatePagination()
};

async function addFile(e) {
  thumb.value = null
  thumb_name.value = ""
  mimeType.value = ""
  
  // 🟢 จุดที่ 1: แก้ไขล้างค่าเริ่มต้นให้กระชับและไม่ขึ้นเส้นแดง
  file_d.value = null;
  thumb_id.value = ""; // ลทิ้งได้ถ้าหน้านี้ไม่มีตัวแปร thumb_id

  if (e.target.files && e.target.files[0] !== undefined) {
    const originalFile = e.target.files[0];
    const maxSize = 10 * 1024 * 1024; // 10 MB

    // 1. เช็คขนาดไฟล์
    if (originalFile.size > maxSize) {
      swal("ขนาดไฟล์เกิน 10 MB", "กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 10 MB", "warning");
      e.target.value = null;
      return;
    }

    // 2. ตั้งชื่อไฟล์และตรวจสอบ MimeType
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let baseName = 'file_' + today

    if (originalFile.type === "image/jpeg") {
      thumb_name.value = baseName + ".jpg"
      mimeType.value = "image/jpeg"
    } else if (originalFile.type === "image/png") {
      thumb_name.value = baseName + ".png"
      mimeType.value = "image/png"
    } else if (originalFile.type === 'application/pdf') {
      thumb_name.value = baseName + ".pdf"
      mimeType.value = "application/pdf"
    } else if (originalFile.type.includes('excel') || originalFile.type.includes('spreadsheetml') || originalFile.name.toLowerCase().endsWith('.xlsx') || originalFile.name.toLowerCase().endsWith('.xls')) {
      thumb_name.value = baseName + ".xlsx"
      mimeType.value = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    } else {
      thumb_name.value = baseName + "_" + originalFile.name
      mimeType.value = originalFile.type
    }

    // 3. เปลี่ยนชื่อไฟล์จริงในโค้ด JavaScript ด้วยโครงสร้าง New File
    const renamedFile = new File([originalFile], thumb_name.value, {
      type: originalFile.type,
      lastModified: originalFile.lastModified
    });

    // บันทึกก้อนไฟล์ดิบที่เปลี่ยนชื่อสำเร็จแล้วไว้ส่ง API
    file_d.value = renamedFile;

    // บันทึก URL พรีวิวภาพลงใน thumb.value เพื่อพรีวิวในแท็ก <img> หน้าเว็บ
    thumb.value = URL.createObjectURL(renamedFile);
  }
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

const getshopInfoApi = async (val) => {
  shop_detail.value = null
  const response = await storec.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log("cashAccShopApi : " + JSON.stringify(response.data.data));
        shop_detail.value = response.data.data
        await loadCashAccDataApi()
        await loadBankPawnApi()
        await loadFinancialtransApi()
        await loadDataApi()
        // await getfundCategoryApi()
        // getTxTypeApi()

      }
    }
  }
}

getshopInfoApi()

const loadBankPawnApi = async (val) => {
  listbankpawn.value = [];
  let data = "";
  data = {
    index: 0,
    size: 100,
    bankUid: '',
    shortName: '',
    acctNumber: '',
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storesb.shopbankListFetch(payload);
  // console.log("loadBankPawnApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // listbankpawn.value = response.data.data.list;
        let listd = response.data.data.list;
        for (let i = 0; i < listd.length; i++) {
          if (listd[i].channels.includes('BO_WEB')) {
            listbankpawn.value.push(listd[i])
          }
        }

      }
    }
  }
}


const loadCashAccDataApi = async (val) => {
  listcashAcc.value = [];
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storec.cashaccountListFetch(payload);

  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // listcashAcc.value = response.data.data.list;
        let listd = response.data.data.list;
        for (let i = 0; i < listd.length; i++) {
          if (listd[i].channels.includes('BO_WEB')) {
            listcashAcc.value.push(listd[i])

          }
        }

      }
    }
  }
}

const loadFinancialtransApi = async (val) => {
  listfinancialtrans.value = [];
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storef.financialTranTypeListFetch(payload);
  // console.log("loadFinancialtransApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listfinancialtrans.value = response.data.data.list;
      }
    }
  }
}

const getTxTypeApi = async () => {

  const response = await storefund.getTxTypeFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log("TxType : " + JSON.stringify(response.data.data));
      }
    }
  }
}


const getfundCategoryApi = async () => {

  const response = await storefund.getfundCategoryInfoFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log("fund : " + JSON.stringify(response.data.data));
      }
    }
  }
}

function cancelBtn() {
  start_date.value = new Date(new Date().setHours(0, 0, 0, 0));
  end_date.value = new Date();
  search_cat.value = '';
  search_subcat.value = '';
  search_trans.value = '';
  search_sourcemoney.value = ''
  currentPage.value = 1
  listfundTx.value = []
  totalRows_s.value = ''
  search_target.value = ''
  loadDataApi()
}

const loadDataApi = async (val) => {
  let data = "";
  let sd = ''
  let ed = ''
  sd = moment(new Date(start_date.value)).format('YYYY-MM-DD')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DD')

  if (currentPage.value !== 1) {
    if (listfundTx.value.length === 1 && val === 'del') {
      currentPage.value = currentPage.value - 1
    }
  }

  let sourceType = ''
  let sourceUid = ''
  let targetType = ''
  let targetUid = ''
  if (search_sourcemoney.value !== '') {
    if (search_sourcemoney.value !== 'OTHERS') {
      sourceType = checkMoneySource(search_sourcemoney.value)
      sourceUid = search_sourcemoney.value
    } else {
      sourceType = 'OTHERS'
    }
  }

  if (search_target.value !== '') {
    if (search_target.value !== 'OTHERS') {
      targetType = checkMoneySource(search_target.value)
      targetUid = search_target.value
    } else {
      targetType = 'OTHERS'
    }
  }

  if (search_sourcemoney.value !== '' || search_cat.value !== '' || search_subcat.value !== '' || search_target.value !== '' && val !== 'del') {
    currentPage.value = 1
  }

  let txType = ''
  if (search_trans.value === 'txTransfer') {
    txType = "TRANSFER"
  } else if (search_trans.value === 'txWithdrawal') {
    txType = "WITHDRAW"

  } else if (search_trans.value === 'txDeposit') {
    txType = "DEPOSIT"
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    start: sd,
    end: ed,
    fundCategory: search_cat.value,
    fundTranTypeId: search_subcat.value,
    txType: txType,
    sourceType: sourceType,
    sourceUid: sourceUid,
    targetType: targetType,
    targetUid: targetUid,

  };


  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storefund.fundTxListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listfundTx.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }
}


async function updatePagination() {
  listfundTx.value = []
  let data = "";
  let sd = ''
  let ed = ''
  sd = moment(new Date(start_date.value)).format('YYYY-MM-DD')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DD')

  let sourceType = ''
  let sourceUid = ''
  let targetType = ''
  let targetUid = ''
  if (search_sourcemoney.value !== '') {
    if (search_sourcemoney.value !== 'OTHERS') {
      sourceType = checkMoneySource(search_sourcemoney.value)
      sourceUid = search_sourcemoney.value
    } else {
      sourceType = 'OTHERS'
    }
  }

  if (search_target.value !== '') {
    if (search_target.value !== 'OTHERS') {
      targetType = checkMoneySource(search_target.value)
      targetUid = search_target.value
    } else {
      targetType = 'OTHERS'
    }
  }

  let txType = ''
  if (search_trans.value === 'txTransfer') {
    txType = "TRANSFER"
  } else if (search_trans.value === 'txWithdrawal') {
    txType = "WITHDRAW"

  } else if (search_trans.value === 'txDeposit') {
    txType = "DEPOSIT"
  }


  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    start: sd,
    end: ed,
    fundCategory: search_cat.value,
    fundTranTypeId: search_subcat.value,
    txType: txType,
    sourceType: sourceType,
    sourceUid: sourceUid,
    targetType: targetType,
    targetUid: targetUid,

  };


  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storefund.fundTxListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listfundTx.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }
}


function checkMoneySource(str) {
  let side = ''
  if (str !== '0') {
    let ld = filterBank(str)
    if (ld.length > 0) {
      side = "BANK_ACCOUNT"
    } else {
      ld = filterCash(str)
      if (ld.length > 0) {
        side = "CASH_ACCOUNT"
      }
    }
  }
  return side
}


function filterCash(str) {
  return listcashAcc.value.filter((c) => c.uid === str);
}

function filterBank(str) {
  return listbankpawn.value.filter((c) => c.uid === str);
}


function filterfundCategory(str) {
  let side = ''
  let ln = datas.FinancAll.filter((c) => c.val === str);
  if (ln.length > 0) {
    side = ln[0].items
  }
  return side
}

function filterfundTranType(str) {
  let side = ''
  let ln = listfinancialtrans.value.filter((c) => c.uid === str);
  if (ln.length > 0) {
    side = ln[0].name
  }
  return side
}


function filterMoneySource(str) {
  let side = ''
  if (str !== '0') {
    let ld = filterBank(str)
    if (ld.length > 0) {
      side = ld[0].shortName
    } else {
      ld = filterCash(str)
      if (ld.length > 0) {
        side = ld[0].name
      }
    }
  }
  return side
}


function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined && num !== '') {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}



function checkSubCat() {
  listsubcat.value = []
  search_subcat.value = ''
  // search_trans.value = ''
  // listtransc.value = []

  if (search_cat.value !== '') {
    let ld = listfinancialtrans.value.filter((c) => c.finCat === search_cat.value);
    if (ld.length > 0) {
      listsubcat.value = ld
      // console.log("listsubcat : " + JSON.stringify(listsubcat.value));
    }
  }

  return listsubcat.value
}


function checkSubCat_AE() {
  listsubcat_ae.value = []
  fundtx_detail.value.fundTranTypeId = ''
  fundtx_detail.value.txType = ''
  listtransc_ae.value = []
  fundtx_detail.value.sourceUid = '0'
  fundtx_detail.value.targetUid = '0'
  fundtx_detail.value.sourceType = ''
  fundtx_detail.value.targetType = ''
  fundtx_detail.value.targetAccNumber = ''
  fundtx_detail.value.sourceAccNumber = ''
  fundtx_detail.value.cusName = ''
  fundtx_detail.value.refNumber = ''
  listsource_ae.value = []
  if (fundtx_detail.value.fundCategory !== '') {
    let ld = listfinancialtrans.value.filter((c) => c.finCat === fundtx_detail.value.fundCategory);
    if (ld.length > 0) {
      listsubcat_ae.value = ld
      // console.log("listsubcat : " + JSON.stringify(listsubcat.value));
    }
  }

  return listsubcat_ae.value
}

function checkTrans_AE() {
  fundtx_detail.value.txType = ''
  listtransc_ae.value = []
  fundtx_detail.value.sourceUid = '0'
  fundtx_detail.value.targetUid = '0'
  fundtx_detail.value.sourceType = ''
  fundtx_detail.value.targetType = ''
  fundtx_detail.value.targetAccNumber = ''
  fundtx_detail.value.sourceAccNumber = ''
  fundtx_detail.value.cusName = ''
  fundtx_detail.value.refNumber = ''
  listsource_ae.value = []
  if (fundtx_detail.value.fundTranTypeId !== '') {
    let ld = listsubcat_ae.value.filter((c) => c.uid === fundtx_detail.value.fundTranTypeId);
    if (ld.length > 0) {
      listtransc_ae.value = ld
      // console.log("listtransc_ae : " + JSON.stringify(listtransc_ae.value));
    }
  }
  return listtransc_ae.value
}


function checkSource_AE() {
  // console.log("txType : " + fundtx_detail.value.txType);
  fundtx_detail.value.sourceUid = '0'
  fundtx_detail.value.targetUid = '0'
  fundtx_detail.value.sourceType = ''
  fundtx_detail.value.targetType = ''
  fundtx_detail.value.targetAccNumber = ''
  fundtx_detail.value.sourceAccNumber = ''
  listsource_ae.value = []
  if (fundtx_detail.value.txType !== '') {
    listsource_ae.value = listtransc_ae.value
  }
  return listsource_ae.value
}

function changeSource() {

  fundtx_detail.value.sourceAccNumber = ''
  if (fundtx_detail.value.sourceUid === 'OTHERS' && fundtx_detail.value.targetUid === 'OTHERS') {
    fundtx_detail.value.targetUid = '0'
  }
}

function changeTarget() {

  fundtx_detail.value.targetAccNumber = ''
  if (fundtx_detail.value.targetUid === 'OTHERS' && fundtx_detail.value.sourceUid === 'OTHERS') {
    fundtx_detail.value.sourceUid = '0'
  }
}


async function confirmNewRecord() {
  if (isLoading.value) return; // ดักเบิ้ลชั้นแรกสุด

  try {
    isLoading.value = true; // สั่งเปิดสถานะโหลดและบล็อกฟังก์ชันทันที

    // ใช้ await ดึงผลลัพธ์จาก swal โดยตรง (ปิดโฟกัสปุ่มตกลงเพื่อกันปุ่ม Enter ค้าง)
    const result = await swal({
      title: "บันทึกธุรกรรม",
      text: "คุณต้องการบันทึกธุรกรรมนี้ใช่ไหม",
      icon: "info",
      allowOutsideClick: false,
      showCloseButton: false,
      showCancelButton: true,
      closeOnConfirm: false,
      focusConfirm: false, // สำคัญมาก: ช่วยกันปัญหาการเผลอกดปุ่ม Enter ค้างบนคีย์บอร์ด
      animation: "slide-from-top",
      confirmButtonText: t("buttons.conf"),
      cancelButtonText: t("buttons.canc"),
    });

    if (result.isConfirmed) {
      if (fundtx_detail.value.uid === '') {
        await addfundTx(); 
      } else {
        await updatefundTx();
      }
    } else if (result.dismiss == "cancel") {
      swal("ยกเลิกรายการ", "", "error");
    }

  } catch (error) {
    console.error("Transaction confirmation error:", error);
    swal("เกิดข้อผิดพลาด", "ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่อีกครั้ง", "error");
  } finally {
    isLoading.value = false; // ปลดล็อกสถานะเมื่อหลังบ้านทำเสร็จสิ้นกระบวนการทั้งหมดแล้ว (สำเร็จหรือล้มเหลวก็ปลดล็อก)
  }
}

async function deleteRowItems(item) {
  swal({
    title: "ลบรายการ",
    text: "คุณต้องการลบรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        deletefundTx(item.uid)
      }
    } else if (result.dismiss == "cancel") {
      swal("ยกเลิกรายการ", "", "error")
    }
  });
}

async function editRowItems(item) {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      clearItem()
      if (item.uid !== '') {
        fundtx_detail.value = {
          uid: item.uid,
          txDate: item.txDate,
          fundCategory: item.fundCategory,
          fundTranTypeId: item.fundTranTypeId,
          txType: item.txType,
          sourceType: item.sourceType,
          sourceUid: item.sourceUid,
          targetType: item.targetType,
          targetUid: item.targetUid,
          txAmount: item.txAmount,
          detail: item.detail,
          refDocUid: item.refDocUid,
          version: item.version,
          targetAccNumber: item.targetAccNumber,
          sourceAccNumber: item.sourceAccNumber,
          cusName: item.cusName,
          refNumber: item.refNumber,
          fundTranTypeName: item.fundTranTypeName,
          sourceAccName: item.sourceAccName,
          targetAccName: item.targetAccName,

        };


        if (fundtx_detail.value.fundCategory !== '' && fundtx_detail.value.fundCategory !== null) {
          let ld = listfinancialtrans.value.filter((c) => c.finCat === fundtx_detail.value.fundCategory);
          if (ld.length > 0) {
            listsubcat_ae.value = ld
          }
        }

        if (fundtx_detail.value.fundTranTypeId !== '' && fundtx_detail.value.fundTranTypeId !== null) {
          let ld = listsubcat_ae.value.filter((c) => c.uid === fundtx_detail.value.fundTranTypeId);
          if (ld.length > 0) {
            listtransc_ae.value = ld
            listsource_ae.value = listtransc_ae.value
          }
        }

        if (fundtx_detail.value.txType === 'TRANSFER') {
          fundtx_detail.value.txType = "txTransfer"
        } else if (fundtx_detail.value.txType === 'WITHDRAW') {
          fundtx_detail.value.txType = "txWithdrawal"
        } else if (fundtx_detail.value.txType === 'DEPOSIT') {
          fundtx_detail.value.txType = "txDeposit"
        }



        if (fundtx_detail.value.sourceType === 'OTHERS') {
          fundtx_detail.value.sourceUid = 'OTHERS'
        }

        if (fundtx_detail.value.targetType === 'OTHERS') {
          fundtx_detail.value.targetUid = 'OTHERS'
        }

        // console.log('edit r : ' + JSON.stringify(item));
        // console.log('fundtx_detail r : ' + JSON.stringify(fundtx_detail.value));

        setsecondTab()
      }

    }
  })
}

function clearItem() {
  thumb.value = null
  fundtx_detail.value = {
    uid: '',
    txDate: new Date(),
    fundCategory: '',
    fundTranTypeId: '',
    txType: '',
    sourceType: '',
    sourceUid: '0',
    targetType: '',
    targetUid: '0',
    txAmount: '',
    detail: '',
    refDocUid: '0',
    version: '',
    targetAccNumber: '',
    sourceAccNumber: '',
  };
  document.getElementById("upload").value = null;
}


async function addfundTx() {
  let txType = "";
  if (fundtx_detail.value.txType === "txTransfer") {
    txType = "TRANSFER";
  } else if (fundtx_detail.value.txType === "txWithdrawal") {
    txType = "WITHDRAW";
  } else if (fundtx_detail.value.txType === "txDeposit") {
    txType = "DEPOSIT";
  }

  let sourceType = fundtx_detail.value.sourceType;
  let sourceUid = fundtx_detail.value.sourceUid;
  if (fundtx_detail.value.sourceUid === "OTHERS") {
    sourceType = "OTHERS";
    sourceUid = "0";
  }

  let targetType = fundtx_detail.value.targetType;
  let targetUid = fundtx_detail.value.targetUid;
  if (fundtx_detail.value.targetUid === "OTHERS") {
    targetType = "OTHERS";
    targetUid = "0";
  }

  thumb_id.value = '0';
  // 1. 🟢 เปลี่ยนมาเช็คว่าผู้ใช้มีการกดคลิกเลือก "ไฟล์หลักฐานใหม่" เข้ามาจากคอมพิวเตอร์จริงหรือไม่ผ่าน file_d.value [INDEX]
  if (file_d.value !== null && file_d.value !== undefined) {
    thumb_id.value = '0'
    
    // สั่งอัปโหลดไฟล์ และดักรับผลสถานะความสำเร็จ (true/false) กลับมาตรวจสอบ [INDEX]
    const isUploadSuccess = await addfileApi();
    
    // 🟢 2. ไฮไลท์จุดเซฟตี้: ถ้าไฟล์หลักฐานอัปโหลดขึ้นหลังบ้านไม่สำเร็จ ให้หยุดทำงานตรงนี้ทันที ไม่เซฟข้อมูลหลักต่อ [INDEX]
    if (!isUploadSuccess) {
      return;
    }
  }

  let fundTranTypeName = filterfundTranType(fundtx_detail.value.fundTranTypeId).trim();
  let sourceAccName = '';
  let targetAccName = '';

  if (sourceUid !== '0' && sourceUid !== 'OTHERS') {
    sourceType = checkMoneySource(sourceUid);
    sourceAccName = filterMoneySource(sourceUid).trim();
  } else {
    if (fundtx_detail.value.sourceAccNumber !== '' && fundtx_detail.value.sourceAccNumber !== null) {
      sourceAccName = "อื่นๆ (" + fundtx_detail.value.sourceAccNumber.trim() + ")";
    } else {
      sourceType = null;
      sourceAccName = '-';
    }
  }

  if (targetUid !== '0' && targetUid !== 'OTHERS') {
    targetType = checkMoneySource(targetUid);
    targetAccName = filterMoneySource(targetUid).trim();
  } else {
    if (fundtx_detail.value.targetAccNumber !== '' && fundtx_detail.value.targetAccNumber !== null) {
      targetAccName = "อื่นๆ (" + fundtx_detail.value.targetAccNumber.trim() + ")";
    } else {
      targetType = null;
      targetAccName = '-';
    }
  }

  let data = {
    txDate: moment(new Date(fundtx_detail.value.txDate)).format('YYYY-MM-DDTHH:mm:ss'),
    fundCategory: fundtx_detail.value.fundCategory,
    fundTranTypeId: fundtx_detail.value.fundTranTypeId,
    txType: txType,
    sourceType: sourceType,
    sourceUid: sourceUid,
    targetType: targetType,
    targetUid: targetUid,
    txAmount: Number(fundtx_detail.value.txAmount).toFixed(2),
    detail: fundtx_detail.value.detail.trim(),
    refDocUid: thumb_id.value,
    targetAccNumber: fundtx_detail.value.targetAccNumber.trim(),
    sourceAccNumber: fundtx_detail.value.sourceAccNumber.trim(),
    cusName: fundtx_detail.value.cusName,
    refNumber: fundtx_detail.value.refNumber,
    fundTranTypeName: fundTranTypeName,
    sourceAccName: sourceAccName,
    targetAccName: targetAccName,
  };

  const response = await storefund.fundTxAddFetch(data);
  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      swal("บันทึกสำเร็จ", "", "success");
      await backfirstTab();
    } else {
      swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      throw new Error(response.data.rtnDesc); // โยน error กลับไปเพื่อให้ฟังก์ชันแม่รู้ว่าบันทึกไม่สำเร็จ
    }
  } else {
    throw new Error("Server communication failed");
  }
}

async function updatefundTx() {
  let txType = "";
  if (fundtx_detail.value.txType === "txTransfer") {
    txType = "TRANSFER";
  } else if (fundtx_detail.value.txType === "txWithdrawal") {
    txType = "WITHDRAW";
  } else if (fundtx_detail.value.txType === "txDeposit") {
    txType = "DEPOSIT";
  }

  let sourceType = fundtx_detail.value.sourceType;
  let sourceUid = fundtx_detail.value.sourceUid;
  if (fundtx_detail.value.sourceUid === "OTHERS") {
    sourceType = "OTHERS";
    sourceUid = "0";
  }

  let targetType = fundtx_detail.value.targetType;
  let targetUid = fundtx_detail.value.targetUid;
  if (fundtx_detail.value.targetUid === "OTHERS") {
    targetType = "OTHERS";
    targetUid = "0";
  }

  // 1. 🟢 เปลี่ยนมาเช็คว่าผู้ใช้มีการกดคลิกเลือก "ไฟล์หลักฐานใหม่" เข้ามาจากคอมพิวเตอร์จริงหรือไม่ผ่าน file_d.value [INDEX]
  if (file_d.value !== null && file_d.value !== undefined) {
    thumb_id.value = '0'
    
    // สั่งอัปโหลดไฟล์ และดักรับผลสถานะความสำเร็จ (true/false) กลับมาตรวจสอบ [INDEX]
    const isUploadSuccess = await addfileApi();
    
    // 🟢 2. ไฮไลท์จุดเซฟตี้: ถ้าไฟล์หลักฐานอัปโหลดขึ้นหลังบ้านไม่สำเร็จ ให้หยุดทำงานตรงนี้ทันที ไม่เซฟข้อมูลหลักต่อ [INDEX]
    if (!isUploadSuccess) {
      return;
    }
  }

  let fundTranTypeName = filterfundTranType(fundtx_detail.value.fundTranTypeId).trim();
  let sourceAccName = '';
  let targetAccName = '';

  if (sourceUid !== '0' && sourceUid !== 'OTHERS') {
    sourceType = checkMoneySource(sourceUid);
    sourceAccName = filterMoneySource(sourceUid).trim();
  } else {
    if (fundtx_detail.value.sourceAccNumber !== '' && fundtx_detail.value.sourceAccNumber !== null) {
      sourceAccName = "อื่นๆ (" + fundtx_detail.value.sourceAccNumber.trim() + ")";
    } else {
      sourceType = null;
      sourceAccName = '-';
    }
  }

  if (targetUid !== '0' && targetUid !== 'OTHERS') {
    targetType = checkMoneySource(targetUid);
    targetAccName = filterMoneySource(targetUid).trim();
  } else {
    if (fundtx_detail.value.targetAccNumber !== '' && fundtx_detail.value.targetAccNumber !== null) {
      targetAccName = "อื่นๆ (" + fundtx_detail.value.targetAccNumber.trim() + ")";
    } else {
      targetType = null;
      targetAccName = '-';
    }
  }

  let data = {
    uid: fundtx_detail.value.uid,
    txDate: moment(new Date(fundtx_detail.value.txDate)).format('YYYY-MM-DDTHH:mm:ss'),
    fundCategory: fundtx_detail.value.fundCategory,
    fundTranTypeId: fundtx_detail.value.fundTranTypeId,
    txType: txType,
    sourceType: sourceType,
    sourceUid: sourceUid,
    targetType: targetType,
    targetUid: targetUid,
    txAmount: Number(fundtx_detail.value.txAmount).toFixed(2),
    detail: fundtx_detail.value.detail.trim(),
    refDocUid: thumb_id.value,
    targetAccNumber: fundtx_detail.value.targetAccNumber.trim(),
    sourceAccNumber: fundtx_detail.value.sourceAccNumber.trim(),
    cusName: fundtx_detail.value.cusName,
    refNumber: fundtx_detail.value.refNumber,
    version: fundtx_detail.value.version,
    fundTranTypeName: fundTranTypeName,
    sourceAccName: sourceAccName,
    targetAccName: targetAccName,
  };

  const response = await storefund.fundTxUpdateFetch(data);
  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      swal("บันทึกสำเร็จ", "", "success");
      await backfirstTab();
    } else {
      swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      throw new Error(response.data.rtnDesc);
    }
  } else {
    throw new Error("Server communication failed");
  }
}


async function deletefundTx(uid) {
  let payload = ""
  payload = {
    uid: uid
  }
  // console.log('delete p : ' + JSON.stringify(payload));
  const response = await storefund.fundTxDeleteFetch(payload);
  // console.log('delete r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('del')
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function addfileApi() {
  // 1. ดักจับเซฟตี้: ถ้าไฟล์นี้เคยอัปโหลดผ่านแล้วและได้ ID มาแล้ว ให้ปล่อยผ่าน (คืนค่า true) ทันที
  if (thumb_id.value && thumb_id.value !== '0') return true;

  // 🟢 2. ดึงก้อนไฟล์ไบนารีแท้ๆ ออกมาจากตัวแปร file_d.value (ลอจิก Base64/replace เก่าเอาออกทั้งหมด)
  const rawFile = file_d.value;

  // หากไม่มีไฟล์ หรือก้อนไฟล์ว่างเปล่า ให้ส่งสัญญาณ false บอกระบบหลัก
  if (!rawFile || !rawFile.name) return false;

  // 🟢 3. จัดทำโครงสร้างวัตถุตามฟอร์แมตที่ API อัปโหลดไฟล์ส่วนกลาง (FormData) ต้องการ
  const payload = {
    files: rawFile, // ส่งไฟล์ไบนารี File Object ที่ผ่านการเปลี่ยนชื่อเรียบร้อยแล้วขึ้นหลังบ้าน [INDEX]
    forGroupUid: shop_detail.value.groupUid,
    forShopUid: shop_detail.value.uid,
    publicAccess: false,
  };

  // 🟢 4. เปลี่ยนมาเรียกฟังก์ชันอัปโหลดแกนกลางตัวจริงที่เราแก้ไว้ใน stores
  const response = await storedoc.uploadFetch(payload);

  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      const resData = response.data.data;
      let uploadedUid = "";

      if (Array.isArray(resData) && resData.length > 0) {
        uploadedUid = resData[0]?.uid || resData;
      } else if (resData && typeof resData === 'object') {
        uploadedUid = resData.uid || resData;
      } else {
        uploadedUid = resData;
      }
      
      const cleanUid = String(uploadedUid).trim();
                            
      thumb_id.value = cleanUid;
      return true; // 🟢 ส่งสัญญาณบอกฟังก์ชันหลักด้านบนว่าอัปโหลดไฟล์เสร็จสมบูรณ์เรียบร้อย [INDEX]
    } else {
      swal("บันทึกไฟล์ไม่สำเร็จ", response.data.rtnDesc, "error");
      return false; // 🟢 ส่งสัญญาณบอกฟังก์ชันหลักให้หยุดบันทึกข้อมูล [INDEX]
    }
  } else {
    const errorMsg = response?.data?.rtnDesc || "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
    swal("บันทึกไฟล์ไม่สำเร็จ", errorMsg, "error");
    return false; // 🟢 ส่งสัญญาณบอกฟังก์ชันหลักให้หยุดบันทึกข้อมูล [INDEX]
  }
}

async function onClickTab(val) {
  if (val === '1') {
    if (end_date.value >= start_date.value) {
      loadDataApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    await setsecondTab()
  }
}

async function backfirstTab() {
  clearItem()
  await onClickTab('1')
}

async function setfirstTab() {
  if (document.getElementById("second-transactions")) {
    document.getElementById("second-transactions").classList.remove('show', 'active')
  }

  if (document.getElementById("secondTransactions")) {
    document.getElementById("secondTransactions").classList.remove('show', 'active')
  }

  if (document.getElementById("first-transactions")) {
    document.getElementById("first-transactions").classList.add('show', 'active')
  }

  if (document.getElementById("firstTransactions")) {
    document.getElementById("firstTransactions").classList.add('show', 'active')
  }
}


async function setsecondTab() {
  if (document.getElementById("first-transactions")) {
    document.getElementById("first-transactions").classList.remove('show', 'active')
  }

  if (document.getElementById("firstTransactions")) {
    document.getElementById("firstTransactions").classList.remove('show', 'active')
  }
  if (document.getElementById("second-transactions")) {
    document.getElementById("second-transactions").classList.add('show', 'active')
  }

  if (document.getElementById("secondTransactions")) {
    document.getElementById("secondTransactions").classList.add('show', 'active')
  }
}


async function getFileRef(item) {
  loading.value = true
  images.value = []
  
  // 1. ตรวจสอบว่ามี refDocUid ผูกมากับข้อมูลจริงไหม
  if (item.refDocUid && item.refDocUid !== "0") {
    
    // 🟢 2. ประกอบโครงสร้าง POST Payload ส่งหา Store ส่วนกลาง
    const payload = {
      groupUid: shop_detail.value.groupUid, // ส่งค่าว่าง หรือดึงจากตัวแปรกรุ๊ปของหน้านี้ (ถ้ามี)
      shopUid: shop_detail.value.uid,  // ดึงจาก key.uid ตามสเปกดั้งเดิมของหน้านี้
      uid: String(item.refDocUid) // รหัสไอดีของไฟล์แนบ
    };

    try {
      // 🟢 3. เรียกใช้งานผ่าน Store แกนกลางที่เราปรับปรุงเป็น POST ไว้เรียบร้อยแล้ว
      const response = await storedoc.getFileFetch(payload);
      
      if (response && response.status === 200 && response.data !== null) {
        const rawData = response.data;
        const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
        
        if (isBlob) {
          // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers)
          const textHead = await rawData.slice(0, 4).text();
          let cleanBlob;
          let fileType;

          if (textHead === "%PDF") {
            cleanBlob = new Blob([rawData], { type: 'application/pdf' });
            fileType = 'application/pdf';
          } else if (textHead.startsWith("PK")) {
            cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          } else {
            // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง ครอบหัวภาพใหม่ให้บราวเซอร์เรนเดอร์รูปได้สวยงาม
            cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
            fileType = 'image/jpeg';
          }

          const dataUrl = URL.createObjectURL(cleanBlob);

          images.value.push({
            src: dataUrl,
            thumbnailImageSrc: dataUrl,
            alt: '',
            title: fileType, 
            filename: 'attachment_' + item.refDocUid, 
            rawBlob: cleanBlob
          });
        }
      }
    } catch (e) {
      console.error("Error in getFileRef POST:", e);
      loading.value = false;
      swal('เกิดข้อผิดพลาด', 'ไม่สามารถดึงไฟล์ได้', 'error');
      return;
    }

    // 🟢 4. แยกเส้นทางการพรีวิวตามประเภทไฟล์จริง (คัดกรองตัวแรกอย่างแม่นยำ)
    if (images.value.length > 0) {
      const targetFile = images.value[0]; 
      const fileType = targetFile.title || "";
      const fileSrc = targetFile.src || "";

      if (fileType === 'application/pdf') {
        // 📄 กรณีเป็น PDF -> เปิดแท็บใหม่
        loading.value = false;
        window.open(fileSrc, '_blank').focus();
        
      } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
        // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดอัตโนมัติพร้อมชื่อสั้นอ่านง่าย
        loading.value = false;
        let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
        let fileNameDownload = `excel_${today}.xlsx`;
        
        const link = document.createElement('a');
        link.href = fileSrc;
        link.setAttribute('download', fileNameDownload);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
      } else {
        // 🖼️ กรณีเป็นรูปภาพ -> เปิดป๊อปอัป Modal หน้าเดิมสวยงาม ไม่เด้งดาวน์โหลด
        loading.value = false;
        setGallery2();
        document.getElementById("attachmenDialog").click();
      }
    } else {
      loading.value = false;
      swal('Record not found', "", "error");
    }
  } else {
    loading.value = false;
    swal('ไม่มีไฟล์แนบในระบบ', "", "warning");
  }
}

function setGallery2() {

  var x = "", i, y = "";

  for (i = 0; i < images.value.length; i++) {

    if (i == 0) {
      x = x + '<div class="carousel-item active"> ' +
        '<img src="' + images.value[i].src + '" class="d-block w-100" alt="..." />' +
        '</div>';
      y = y + '<button type = "button" data-bs-target="#attachmentsImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      x = x + '<div class="carousel-item"> ' +
        '<img src="' + images.value[i].src + '" class="d-block w-100" alt="..." />' +
        '</div>';
      y = y + '<button type = "button" data-bs-target="#attachmentsImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo2").innerHTML = y;
  document.getElementById("demo3").innerHTML = x;

}


onMounted(() => {

  if (document.getElementById("first-transactions")) {
    document.getElementById("first-transactions").classList.add('show', 'active')
  }

  if (document.getElementById("firstTransactions")) {
    document.getElementById("firstTransactions").classList.add('show', 'active')
  }
});

</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
